module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/calculator/calculator-item/individual-calculator/individual-travel/individual-flights-list/individual-flights-list.component.css
// module id = ./src/app/components/calculator/calculator-item/individual-calculator/individual-travel/individual-flights-list/individual-flights-list.component.css
// module chunks = main